import Flickity from 'flickity';

// Make an index of carousels for potential use later in theme editor
const carousels = {};
const carousels_mobile = {};

// The main function that actually initializes the carousels
const carouselInit = (section_id, carousel, index) => {
  const slide_count = carousel.children.length;

  if (slide_count < 2) {
    // Don't init pointless carousels with no slides
    return;
  }

  let object = carousels;
  if (carousel.id.indexOf('mobile') >= 0) {
    object = carousels_mobile;
  }

  const data = carousel.dataset;
  let prev_next_buttons = data.prevNextButtons === 'true';
  let page_dots = data.pageDots === 'true';
  let draggable = data.draggable === 'true';

  if (slide_count === 1) {
    prev_next_buttons = false;
    page_dots = false;
    draggable = false;
  }

  object[section_id] = new Flickity(carousel, {
    initialIndex: index || 0,
    prevNextButtons: prev_next_buttons,
    pageDots: page_dots,
    wrapAround: data.wrapAround === 'true',
    autoPlay: data.autoPlay === 'true',
    pauseAutoPlayOnHover: data.pauseAutoPlayOnHover === 'true',
    dragThreshold: window.theme.flickity.dragThreshold,
    adaptiveHeight: true,
    imagesLoaded: true,
    draggable: draggable,
    setGallerySize: true,
  });

  object[section_id].on('change', () => {
    // This is now called 'heroCarouselDidChange' but leaving the old name for backwards-compatability
    const event1 = new CustomEvent('heroCarouselChange', { detail: section_id });
    document.dispatchEvent(event1);
    const event2 = new CustomEvent('heroCarouselDidChange', { detail: section_id });
    document.dispatchEvent(event2);
  });

  carousel.style.overflow = 'visible';
};

export { carousels, carousels_mobile, carouselInit };
